import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { first, map } from 'rxjs/operators';

import { ResponsePaginateSuccess, ResponseSuccess } from '@atmi/core/models';

import { generateIndexQueryString, IndexQueryStringType } from '@atmi/core/utils';
import { UserModuleConfiguration } from '@sim/users/models/configuration';
import { User } from '@sim/users/models/user';
import { UserConfigurationService } from '@sim/users/token';

@Injectable()
export class UsersApiService {

  private readonly path = `${this.config.basePath}/users`;

  constructor(
    @Inject(UserConfigurationService) private readonly config: UserModuleConfiguration,
    private readonly http: HttpClient,
  ) {
  }

  index(queryString?: IndexQueryStringType) {
    const params = generateIndexQueryString(queryString);

    return this.http.get<ResponsePaginateSuccess<User[]>>(this.path, { params }).pipe(
      map((res) => ({ data: res.data, count: res.count })),
    );
  }

  get(id: string) {
    return this.http.get<ResponseSuccess<User>>(`${this.path}/${id}`).pipe(
      map((res) => res.data),
    );
  }

  post(user: User) {
    return this.http.post<ResponseSuccess<User>>(this.path, user).pipe(
      map((res) => res.data),
      first(),
    );
  }

  put(user: User) {
    return this.http.put<ResponseSuccess<User>>(`${this.path}/${user.id}`, user).pipe(
      map((res) => res.data),
      first(),
    );
  }

  remove(id: string) {
    return this.http.delete(`${this.path}/${id}`).pipe(first());
  }

}
